import Glide from '@glidejs/glide';
import { Swipe, Anchors } from '@glidejs/glide/dist/glide.modular.esm';

const setupSlider = (targetElement, options = {}) => {
  new Glide(targetElement, options).mount({ Swipe, Anchors });
};

export default setupSlider;
